<template>
  <el-form
    size="small"
    ref="form"
    :model="formData"
    :rules="rules"
    label-width="100px"
    inline-message
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="登记时间" prop="logTime">
          <el-date-picker
            style="width:100%"
            v-model="formData.logTime"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetime"
            placeholder="请选择异常登记时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="异常类型" prop="transAbnormalType">
          <dict-select
            clearable
            style="width:100%"
            v-model="formData.transAbnormalType"
            placeholder="请选择异常类型"
            default
            filterable
            :body="selectTransAbnormalType"
            :selectedLabel.sync="formData.transAbnormalTypeName"
          >
          </dict-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="异常事件" prop="transAbnormalEventType">
          <dict-select
            v-model="formData.transAbnormalEventType"
            placeholder="请选择异常事件"
            :body="selectTransAbnormalEventType"
            :selectedLabel.sync="formData.transAbnormalEventTypeName"
            style="width:100%"
            clearable
            default
            filterable
          >
          </dict-select>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="上报客户" prop="isSendCustomer">
          <el-select
            v-model="formData.isSendCustomer"
            style="width:100%"
            placeholder="请选择是否上报客户"
          >
            <el-option label="否" value="N"> </el-option>
            <el-option label="是" value="Y"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="货物迟到数量">
          <el-input-number
            clearable
            v-model="formData.transAbnormalQty"
            controls-position="right"
            :min="0"
            :max="100000"
            :step-strictly="true"
            :step="1"
            style="width:100%"
            placeholder="请输入货物迟到数量"
          >
          </el-input-number>
        </el-form-item>
      </el-col>

      <el-col :span="12">
        <el-form-item label="客户投诉" prop="isComplaint">
          <el-select
            v-model="formData.isComplaint"
            style="width:100%"
            placeholder="请选择是否为客户投诉"
          >
            <el-option label="否" value="N"> </el-option>
            <el-option label="是" value="Y"> </el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <el-form-item label="情况说明" prop="abnormalDesc">
          <el-input
            v-model="formData.abnormalDesc"
            clearable
            type="textarea"
            rows="7"
            placeholder="请输入异常情况说明"
            maxlength="1000"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-row :span="24" class="ml-2">
        <el-form-item label="添加图片">
          <el-upload
            ref="upload"
            action="/store/oss/upload"
            list-type="picture-card"
            :auto-upload="false"
            multiple
            :on-change="onUploadChange"
            accept="image/png,image/jpeg"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-row>
    </el-row>
  </el-form>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      selectTransAbnormalType: { type: 'transAbnormalType' },
      selectTransAbnormalEventType: { type: 'transAbnormalEventType' },
      rules: {
        logTime: [
          { required: true, message: '请选择异常登记时间', trigger: 'change' },
        ],
        transAbnormalType: [
          { required: true, message: '请选择异常类型', trigger: 'change' },
        ],
        transAbnormalEventType: [
          { required: true, message: '请选择异常事件', trigger: 'change' },
        ],
        isSendCustomer: [
          { required: true, message: '请选择是否上报客户', trigger: 'change' },
        ],
        isComplaint: [
          {
            required: true,
            message: '请选择是否为客户投诉',
            trigger: 'change',
          },
        ],
      },
      formData: {},
      listImage: [],
    }
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const length = this.data.length
      if (!length) return

      const loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      let listImage = []
      try {
        listImage = await this.uploadImages()
      } catch (err) {
        loadingInstance.close()
        this.$message({
          showClose: true,
          message: '图片上传错误，请检查后重试',
          type: 'error',
        })
        return
      }
      const listCode = this.data.map((item) => item.waybillDetailCode)
      const params = { listImage, listCode, ...this.formData }
      this.$api
        .carrierWaybillAbnormalRegisterApi(params)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    onUploadChange(file, fileList) {
      this.listImage = fileList
    },
    uploadImages() {
      if (!this.listImage || !this.listImage.length) {
        return Promise.resolve([])
      }
      const uploadTask = this.listImage.map((image) => {
        return this.$api.SYS_UPLOAD(image.raw).then((res) => ({
          imageCode: res.body.id,
          imageUrl: res.body.url,
        }))
      })
      return Promise.all(uploadTask)
    },
  },
}
</script>
